import {useLocalizedNavigation} from 'modules/navigation/hooks';
import {useRouter} from 'next/router';
import {useLazyPromise} from 'utils/async';
import {useConsole} from 'utils/console';
import {getCaptchaToken} from 'utils/recaptcha';
import {apiSignup} from './api';

/**
 * Structure of signup form, which will be stored into the context.
 */
export interface ISignup {
	username: string;
	password: string;
	passwordConfirm: string;
	step: string;
	firstName: string;
	lastName: string;
}

export type SignupStep = 'credentials' | 'profile' | 'success';

export interface SignupForm {
	username: string;
	password: string;
	accType: string;
	firstName: string;
	lastName: string;
	rgpd: boolean;
}

export interface LocalSignupForm extends SignupForm {
	step: SignupStep;
	passwordConfirm: string;
}

export const useSignup = () => {
	const {wlog} = useConsole();
	const {push} = useLocalizedNavigation();
	const router = useRouter();

	const signupOperation = useLazyPromise(async (input: SignupForm) => {
		wlog.debug('Input of signup form', input.accType);
		const recaptcha: string = await getCaptchaToken('signup');
		await apiSignup({
			email: input.username,
			username: input.username,
			password: input.password,
			accType: input.accType,
			firstName: input.firstName,
			lastName: input.lastName,
			rgpd: input.rgpd,
			corporateFunction: '',
			recaptcha: recaptcha,
			preferredLanguage: router.locale
		});
		push('authSignupSuccess', input.username);
	});

	return {
		signupOperation
	};
};
